import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import packageJson from "../../../package.json";
import { themes, supportLabel } from "services/constants";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { setCurrentLocation } from "services/Redux/userToken";
import {
  setEditUserDetailsApi,
  setProfileEditBack,
  setEditUserId,
  setSidebarExpand,
  setCurrentScreen,
  setSubMenuExpand,
} from "services/Redux/userManagament";

import { useSelector, useDispatch } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { customGetAPI } from "services/utils/CustomAPI";
import { useHistory } from "react-router-dom";
import {
  Close,
  Person2,
  Dns,
  LockReset,
  TouchApp,
  Task,
} from "@mui/icons-material";
import { rowEndStyle } from "services/constants/Styles";
export const UserSidePeek = ({
  openSidePeek,
  setOpenSidePeek,
  firstLetter,
  userDetails,
  updateProfileSidePeek,
  setUpdateProfileSidePeek,
  fetchData,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { productAccess, domain } = useSelector((state) => state.tokenReducer);
  const [actionData, setActionData] = useState([]);
  const [doAnyAct, setDoAnyAct] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [teantCount, setTenatCount] = useState(0);

  useEffect(() => {
    const getTenantDetails = async () => {
      const url = userDetails?.email
        ? `${domain}user_tenant/details/?email=${userDetails?.email}`
        : `${domain}user_tenant/details/?phone_number=${userDetails?.phone_number}`;
      const res = await customGetAPI(url);
      if (res.ok) {
        setTenatCount(res?.responseDetails?.length);
      }
    };
    if (userDetails && userDetails?.type === supportLabel) {
      getTenantDetails();
    }
  }, [domain, userDetails]);

  useEffect(() => {
    if (updateProfileSidePeek) {
      const hasProject = productAccess?.some(
        (product) => product.product_name === "Project"
      );
      let actionDetails = [
        { id: 1, label: "My Profile", icon: <Person2 fontSize="small" /> },
        {
          id: 4,
          label: "Change Password",
          icon: <LockReset fontSize="small" />,
        },
        {
          id: 5,
          label: "Bio Metric Status",
          icon: <TouchApp fontSize="small" />,
        },
      ];
      if (teantCount > 1) {
        actionDetails?.splice(1, 0, {
          id: 2,
          label: "Change Domain",
          icon: <Dns fontSize="small" />,
        });
      }
      if (hasProject) {
        actionDetails?.splice(teantCount > 1 ? 2 : 1, 0, {
          id: 3,
          label: "Task",
          icon: <Task fontSize="small" />,
        });
      }
      setActionData(actionDetails);
      setUpdateProfileSidePeek(false);
    }
  }, [
    actionData,
    productAccess,
    setUpdateProfileSidePeek,
    teantCount,
    updateProfileSidePeek,
  ]);

  const handleCloseDialogBox = () => {
    setOpenDialog(false);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Mui.Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenSidePeek(open);
    if (open === false) {
      if (doAnyAct) {
        setDoAnyAct(false);
      }
    }
  };

  const logoutCurrentUser = () => {
    localStorage.clear();
    localStorage.setItem("LoginTag", "Email");
    window.location.reload();
  };

  const buttonAction = (item) => {
    if (item.label === "My Profile") {
      dispatch(setSidebarExpand(false));
      dispatch(setEditUserId(userDetails?.id));
      dispatch(setEditUserDetailsApi(true));
      dispatch(setProfileEditBack(false));
      dispatch(setGlobalSearchValue(""));
      history.push("/admin/edit/profile/");
    } else if (item.label === "Change Password") {
      dispatch(setGlobalSearchValue(""));
      history.push("/admin/changepassword");
    } else if (item.label === "Change Domain") {
      dispatch(setGlobalSearchValue(""));
      history.push("/admin/change/domain");
    } else if (item.label === "Task") {
      dispatch(setGlobalSearchValue(""));
      dispatch(setCurrentLocation("Project"));
      localStorage.setItem("currentScreen", "Tasks");
      dispatch(setCurrentScreen("Tasks"));
      dispatch(setSubMenuExpand(false));
      history.push("/admin/project/mytask");
    } else if (item.label === "Bio Metric Status") {
      fetchData();
    }
    setOpenSidePeek(false);
  };

  return (
    <React.Fragment>
      <Mui.Drawer
        anchor="right"
        open={openSidePeek}
        onClose={toggleDrawer("right", false)}
        PaperProps={{
          sx: {
            width: {
              xs: 300,
              sm: 360,
              md: 400,
              lg: 400,
            },
          },
        }}
      >
        <Mui.Grid container sx={{ padding: 1, ...rowEndStyle }}>
          <Mui.IconButton onClick={() => setOpenSidePeek(false)}>
            <Close sx={{ color: themes.closeIcon }} />
          </Mui.IconButton>
        </Mui.Grid>
        <Mui.Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "10vh" }}
        >
          <Mui.Box
            sx={{
              position: "relative",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              width: 100,
              height: 100,
            }}
          >
            <Mui.CircularProgress
              variant="determinate"
              size={80}
              thickness={1}
              sx={{
                color: themes.primaryIndicator,
              }}
              value={100}
            />
            <Mui.Box
              sx={{
                position: "absolute",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 60,
                height: 60,
              }}
            >
              <Mui.Avatar
                sx={{
                  width: 60,
                  height: 60,
                  bgcolor: "purple",
                }}
                alt={firstLetter}
                src={userDetails?.image_url}
              />
            </Mui.Box>
          </Mui.Box>
        </Mui.Grid>
        <Mui.Stack sx={{ justifyContent: "center", alignItems: "center" }}>
          <Mui.Typography
            sx={{
              fontWeight: "bold",
              fontSize: 18,
              fontFamily: "sans-serif",
            }}
          >
            {userDetails?.first_name}
          </Mui.Typography>
          <Mui.Typography sx={{ fontSize: 15, fontFamily: "sans-serif" }}>
            {userDetails?.role}
          </Mui.Typography>
          <Mui.Typography sx={{ fontSize: 15, fontFamily: "sans-serif" }}>
            {userDetails?.email}
          </Mui.Typography>
        </Mui.Stack>
        <Mui.Stack sx={{ paddingTop: 1 }}>
          <Mui.Box
            sx={{
              borderRadius: 2,
              width: "100%",
              overflow: "visible",
            }}
          >
            {actionData.map((item, index) => (
              <Mui.ListItem
                key={index}
                disableGutters
                sx={{
                  width: "100%",
                  paddingY: 1,
                  paddingX: 1.5,
                  transition: "all 0.2s ease-in-out",
                  borderRadius: 2,
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                    ".icon-box": {
                      backgroundColor: "#999",
                    },
                  },
                }}
                onClick={() => {
                  buttonAction(item);
                }}
              >
                <Mui.ListItemIcon
                  sx={{
                    minWidth: "auto",
                    marginRight: 1.5,
                  }}
                >
                  <Mui.Box
                    className="icon-box"
                    sx={{
                      backgroundColor: "#B0B0B0",
                      borderRadius: "8px",
                      padding: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "32px",
                      height: "32px",
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    {item.icon}
                  </Mui.Box>
                </Mui.ListItemIcon>
                <Mui.ListItemText
                  primary={item.label}
                  primaryTypographyProps={{ fontSize: 16, fontWeight: 500 }}
                  sx={{
                    color: themes.shadowText,
                    margin: 0,
                    transition: "color 0.2s ease",
                    "&:hover": {
                      color: themes.headLine,
                      fontSize: 17,
                    },
                  }}
                />
              </Mui.ListItem>
            ))}
          </Mui.Box>
        </Mui.Stack>
        {/* Logout button */}
        <Mui.Box
          sx={{
            position: "absolute",
            bottom: 8,
            left: 0,
            right: 0,
            paddingX: 2,
          }}
        >
          <Mui.ListItem
            disableGutters
            button
            sx={{
              width: "100%",
              paddingY: 1,
              paddingX: 1.5,
              transition: "all 0.2s ease-in-out",
            }}
          >
            <Mui.ListItemText
              primary={packageJson.version}
              primaryTypographyProps={{ fontSize: 16, fontWeight: 500 }}
              sx={{
                color: themes.headLine,
                margin: 0,
                textAlign: "center",
                transition: "color 0.2s ease",
              }}
            />
          </Mui.ListItem>
          <Mui.ListItem
            disableGutters
            button
            sx={{
              width: "100%",
              paddingY: 1,
              paddingX: 1.5,
              transition: "all 0.2s ease-in-out",
              backgroundColor: themes.primaryIndicator,
              borderRadius: 2,
              "&:hover": {
                backgroundColor: themes.primaryIndicator,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                ".icon-box": {
                  backgroundColor: "#999",
                },
                color: themes.headLine,
                fontSize: 20,
              },
            }}
            onClick={() => {
              setOpenDialog(true);
              setOpenSidePeek(false);
            }}
          >
            <Mui.ListItemText
              primary="Log out"
              primaryTypographyProps={{ fontSize: 16, fontWeight: 500 }}
              sx={{
                color: themes.headLine,
                margin: 0,
                textAlign: "center",
                transition: "color 0.2s ease",
              }}
            />
          </Mui.ListItem>
        </Mui.Box>
      </Mui.Drawer>
      <GlobalDialogBox
        handleCloseDialog={handleCloseDialogBox}
        open={openDialog}
        title="Logout"
      >
        <Mui.Grid container>
          <Mui.Grid item xs={12}>
            <Mui.Typography fontSize={24}>
              Are you sure you want to log out?
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid container>
          <Mui.Grid item xs={8}></Mui.Grid>
          <Mui.Grid item xs={2}>
            <CustomButton
              actionFuntion={handleCloseDialogBox}
              actionName="No"
              typeName="button"
            />
          </Mui.Grid>
          <Mui.Grid item xs={2}>
            <CustomButton
              actionFuntion={logoutCurrentUser}
              actionName="Yes"
              typeName="button"
            />
          </Mui.Grid>
        </Mui.Grid>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
